<template>
  <div class="requisites-group-container" v-if="container.containers.length > 0 || container.relationships.length > 0">
    <div class="requisites-group">

      <template v-for="(subcontainer, index) in container.containers">
        <SlideOutUnitDetailsPreReq :container="subcontainer" :index="index" v-bind:key="index" :displayRequirements="displayRequirements" :displayExclusions="displayExclusions"
          :parentConnector="container.connector" :lastElement="index == (container.containers.length -1)" />
      </template>

      <div class="requisites-cell" v-for="(rel, index) in container.relationships" v-bind:key="index">
        <div class="connector" v-if="index < container.relationships.length">
          <span class="connector-text">
            {{container.connector}}
          </span>
        </div>
        <SlideOutUnitDetailsPreReqCard :displayRequirements="displayRequirements" :displayExclusions="displayExclusions" :rel="rel" :course="course"
          :unitCodeFound="selectedUnitCodes.some(a => a == rel.code)" />
      </div>

    </div>

    <div class="connector" v-if="!lastElement">
      <span class="connector-text">
        {{parentConnector || "AND"}}
      </span>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Curriculum from 'client/js/models/curriculum'
import SlideOutUnitDetailsPreReqCard from './SlideOutUnitDetailsPreReqCard.vue'

export default {
  props: {
    container: {
      type: Object,
      required: true
    },
    lastElement: {
      type: Boolean,
      required: true
    },
    parentConnector: {
      type: String,
      required: false
    },
    displayRequirements: {
      type: Boolean,
      required: false
    },
    displayExclusions: {
      type: Boolean,
      required: false
    },
    generalElectives: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      loading: null,
      displaySuccessSnack: false,
      displaySuccessSnackContainer: null
    }
  },
  methods: {
    ...mapActions({
      // attachStructure: 'courses/attachStructure',
      // addRelationships: 'courses/addRelationships',

      // addItem: 'units/addCurriculumItem'
    }),
    // getGeneralElectiveStructure() {
    //   const generalElectiveStructure = this.course.structure[0].containers[this.course.structure[0].containers.length - 1].container.filter(
    //     (x) => x.verticalGrouping == 'General Elective'
    //   )
    //   return generalElectiveStructure.length > 0 ? generalElectiveStructure[0] : null
    // },

    // async getRelationshipUnit(index) {
    //   this.loading = true
    //   const unit = this.container.relationships[index]
    //   const thisCourse = this.course

    //   const containerFirst = this.course.structure[0].containers[this.course.structure[0].containers.length - 1]
    //   const generalElectives = this.getGeneralElectiveStructure()

    //   // const query = generalElectives.conditionSet[0].query
    //   // const searchQuery = `condition-set-url=${query}&title-or-code-search-term=${unit.code}`
    //   // const ConditionSetResponse = await Curriculum.searchConditionSet(searchQuery)

    //   // const ResponseItems = ConditionSetResponse?.items?.filter((c) => c.code == unit.code)

    //   const conditionSetId = generalElectives.cl_id
    //   const SearchResponse = await Curriculum.searchCachedConditionSet(conditionSetId, this.rel.code, this.includeDraftVersions)
    //   const ResponseItems = SearchResponse?.items?.filter((c) => c.code == unit.code)


    //   if (ResponseItems.length > 0) {
    //     const ResponseRelationshipItem = ResponseItems[0]

    //     //add unit 'cos we actually haven't got it yet
    //     ResponseRelationshipItem.unit = await Curriculum.getUnit(ResponseRelationshipItem.code, ResponseRelationshipItem.version)
    //     return ResponseRelationshipItem
    //   }
    //   return null
    // },

    // async canAdd(index) {
    //   const relationshipUnit = await this.getRelationshipUnit(index)
    //   return relationshipUnit !== null
    // },
    // async addUnit(index) {
    //   this.loading = this.container.relationships[index].code
    //   const unit = this.container.relationships[index]
    //   const thisCourse = this.course

    //   const containerFirst = this.course.structure[0].containers[this.course.structure[0].containers.length - 1]
    //   const generalElectives = this.getGeneralElectiveStructure()

    //   // const query = generalElectives.conditionSet[0].query
    //   // const searchQuery = `condition-set-url=${query}&title-or-code-search-term=${unit.code}`
    //   // const ConditionSetResponse = await Curriculum.searchConditionSet(searchQuery)

    //   // const ResponseItems = ConditionSetResponse?.items?.filter((c) => c.code == unit.code)

    //   const conditionSetId = generalElectives.cl_id
    //   const SearchResponse = await Curriculum.searchCachedConditionSet(conditionSetId, this.rel.code, this.includeDraftVersions)
    //   const ResponseItems = SearchResponse?.items?.filter((c) => c.code == unit.code)

    //   if (ResponseItems.length > 0) {
    //     const ResponseRelationshipItem = ResponseItems[0]

    //     //add unit 'cos we actually haven't got it yet
    //     ResponseRelationshipItem.unit = await Curriculum.getUnit(ResponseRelationshipItem.code, ResponseRelationshipItem.version)

    //     //  This assumes only two levels
    //     const electiveLocation = 'root' + '>' + containerFirst.title + '-' + containerFirst.order + '>' + generalElectives.title + '-' + generalElectives.order
    //     const newLocation = electiveLocation + '>' + ResponseRelationshipItem.code

    //     // Add items to Journey's curriculum items
    //     this.addItem({
    //       firstLevelTitle: containerFirst.title, // this.firstLevelTitle,
    //       relationship: ResponseRelationshipItem,
    //       location: newLocation,
    //       verticalGrouping: generalElectives.verticalGrouping // this.verticalGrouping
    //     })

    //     // Add new item to the journeys course to the relationship structure
    //     this.addRelationships({
    //       location: electiveLocation,
    //       relationships: [ResponseRelationshipItem]
    //     })

    //     this.loading = null
    //     this.showSuccessSnack(this.container.relationships[index].code, generalElectives.title)
    //   }
    // },
    // showSuccessSnack(unit, container) {
    //   setTimeout(() => ((this.displaySuccessSnack = unit), (this.displaySuccessSnackContainer = container)), 250)
    //   setTimeout(() => (this.displaySuccessSnack = false), 4000)
    // }
  },
  computed: {
    ...mapGetters({
      course: 'courses/getSelectedCourse',
      selectedUnitCodes: 'units/getSelectedUnitCodes',
      // includeDraftVersions: 'courses/includeDraftVersions'
    })
  },
  components: { SlideOutUnitDetailsPreReq: () => import('./SlideOutUnitDetailsPreReq.vue'), SlideOutUnitDetailsPreReqCard }
}
</script>
